const listItemTypes = {
  SCRUBBING_RULE: 'scrubbingRule',
};

export default listItemTypes;
